// @flow
import React from 'react';
import styles from './Copyright.module.scss';
import { useAppDarkMode } from '../../../hooks';


type Props = {
  copyright: string
};

const Copyright = ({ copyright }: Props) => {
  const { value } = useAppDarkMode(false);
  return (
    <div className={styles[value ? 'dark-copyright' : 'light-copyright']}>
      {copyright}
      <br></br>
      <a className={styles[value ? 'dark-copyright-link' : 'light-copyright-link']} href="https://pebbler.substack.com" target="_blank">Link to my Newsletter</a>
      <br></br>
      <a className={styles[value ? 'dark-copyright-link' : 'light-copyright-link']} href="https://unsplash.com/illustrations/a-cute-cartoon-orange-with-a-happy-face-oOcjEsfxuz4?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText" target="_blank">Profile illustration</a> by <a className={styles[value ? 'dark-copyright-link' : 'light-copyright-link']} href="https://unsplash.com/@bilqisnuramalia/illustrations?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText" target="_blank">Bilqis Nur Amalia</a> on <a className={styles[value ? 'dark-copyright-link' : 'light-copyright-link']} href="https://unsplash.com/illustrations?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText" target="_blank">Unsplash</a>
    
    </div>
  );
}

export default Copyright;